import { PutUsersPutRequestModel } from "@/features/user/services/put-users-model";
import { PutUsersApi } from "@/features/user/services/put-users-api";

// 利用者情報更新処理
export class PutUsersService {
  private putUsersApi = new PutUsersApi();
  /**
   * 利用者情報更新API実行
   */
  public async putUsers(param: PutUsersPutRequestModel) {
    return await this.putUsersApi.putUsers(param);
  }
}
